module.exports = __webpack_public_path__ + "static/envelope-diagrams_01-e99cb48e59667d6b543d9ffa5b136cd7.svg";